import * as React from 'react';
import CopyToClipboard from "../general/CopyToClipboard.tsx";
import {PrimaryButton} from "../general/PrimaryButton.tsx";

interface PartnerNoClientsYetEmptyStateProps {
    onAddBusinessClick?: () => void;
    onboardingUrl: string;
}

export function PartnerNoClientsYetEmptyState({onAddBusinessClick, onboardingUrl}: PartnerNoClientsYetEmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center h-full mt-12">
            <h1 className="text-center text-2xl font-semibold pb-4 text-gray-400">
                Nog geen klanten
            </h1>
            <p className="text-center text-md pb-4 text-gray-400">
                We zijn er bijna! Je hebt nog geen gekoppelde klanten.
            </p>
            {onAddBusinessClick && (
                <div className="pb-6">
                    <PrimaryButton title="Bedrijf toevoegen" onClick={onAddBusinessClick}/>
                </div>
            )}
            {onboardingUrl && (
                <>
                    <p className="text-center text-md pb-8 text-gray-400">
                        Of deel de onderstaande link met je klanten zodat zij zich kunnen aanmelden:
                    </p>
                    <div>
                        <CopyToClipboard text={onboardingUrl}/>
                    </div>
                </>
            )}
        </div>
    );
}
